import "./header.scss";

import { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import Button from "common/core/button";
import { DOCUMENT_UPLOADER_REQUIREMENTS_INSTRUCTIONS } from "constants/aria-describedby";

/**
 * Private component that is the header of a document uploader manager. It includes add, delete many
 * documents and change the property of many documents.
 */
class DocumentUploaderManagerHeader extends Component {
  render() {
    const {
      onAddDocuments,
      hasEditColumn,
      requestOpenAnnotate,
      isAnnotating,
      canSetDocRequirements,
      canSetDocPermissions,
      hideAnnotateButton,
      requiresNsaMeeting,
      readOnly,
    } = this.props;

    const tooltipClasses = classnames("DocumentUploaderManagerHeader--TooltipHeader", {
      "DocumentUploaderManagerHeader--TooltipHeader__withEditing": hasEditColumn,
    });

    const requirementsText = requiresNsaMeeting ? (
      <p id={DOCUMENT_UPLOADER_REQUIREMENTS_INSTRUCTIONS}>
        <FormattedMessage
          id="a6b8a1fb-68f3-4118-8afb-d70347303993"
          defaultMessage="Select to set requirements"
        />
      </p>
    ) : null;

    return (
      <div className="DocumentUploaderManagerHeader">
        {!hideAnnotateButton && (
          <Button
            variant="secondary"
            buttonColor="action"
            onClick={requestOpenAnnotate}
            disabled={isAnnotating}
            automationId="document-uploader-review-documents"
          >
            {readOnly ? (
              <FormattedMessage id="0ca4fa58-a7b9-419b-ba19-4b4aecd335e1" defaultMessage="Review" />
            ) : (
              <FormattedMessage
                id="04355802-4037-4aa2-acbe-69536e74837d"
                description="reviewButton"
                defaultMessage="Fill Out Document"
              />
            )}
          </Button>
        )}
        {onAddDocuments && (
          <Button
            buttonColor="action"
            variant="primary"
            onClick={onAddDocuments}
            disabled={isAnnotating}
            automationId="document-uploader-add-documents"
          >
            <FormattedMessage
              id="33e78c2f-425d-4717-80c0-85f8e7dc6b23"
              description="addDocumentsButton"
              defaultMessage="Add Documents"
            />
          </Button>
        )}
        {(canSetDocRequirements || canSetDocPermissions) && (
          <div className={tooltipClasses}>{requirementsText}</div>
        )}
      </div>
    );
  }
}

DocumentUploaderManagerHeader.propTypes = {
  /** Called with object of `{ signerCanAnnotate, witnessRequired, notarizationRequired }` booleans */
  onAddDocuments: PropTypes.func,
  hasEditColumn: PropTypes.bool,
  isAnnotating: PropTypes.bool,
  requestOpenAnnotate: PropTypes.func,
  canSetDocRequirements: PropTypes.bool,
  canSetDocPermissions: PropTypes.bool,
  hideAnnotateButton: PropTypes.bool,
  requiresNsaMeeting: PropTypes.bool,
  readOnly: PropTypes.bool,
};

DocumentUploaderManagerHeader.defaultProps = {
  canSetDocRequirments: true,
  canSetDocPermissions: true,
  hideAnnotateButton: false,
  isAnnotating: false,
  requiresNsaMeeting: true,
};

export default DocumentUploaderManagerHeader;
